import { BlockResult } from '@block-explorer/entities';
import { createAsyncAction } from 'typesafe-actions';
import {
  DataResponse,
  PaginatedResponse,
  PaginationParams,
} from '../../services';

export const getPaginatedBlocksAsync = createAsyncAction(
  'GET_PAGINATED_BLOCKS_REQUEST',
  'GET_PAGINATED_BLOCKS_SUCCESS',
  'GET_PAGINATED_BLOCKS_FAILURE'
)<Partial<PaginationParams>, PaginatedResponse<BlockResult>, string>();

export const getBlockByHashAsync = createAsyncAction(
  'GET_BLOCK_BY_HASH_REQUEST',
  'GET_BLOCK_BY_HASH_SUCCESS',
  'GET_BLOCK_BY_HASH_FAILURE'
)<{ hash: string }, DataResponse<BlockResult>, string>();
